import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import adminApi from "@/lib/adminApi";
import BrandMark from "@/components/BrandMark";

export default function AdminResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState({ new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (pwd.new_password !== pwd.confirm) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await adminApi.post("/reset-password/confirm", { token, new_password: pwd.new_password });
      toast.success("Password reset — please sign in.");
      navigate("/admin/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <BrandMark variant="center" className="mb-8" />
        <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] mb-4 text-center">Aynora · Admin</div>
        <h1 className="font-[Cormorant_Garamond] text-4xl leading-tight tracking-tight text-stone-900 mb-8 text-center">Choose a new password</h1>
        {!token && <p className="text-sm text-red-600 mb-4">Missing token — use the link from your reset email.</p>}
        <div className="flex flex-col gap-4">
          <input data-testid="admin-reset-new-password" type="password" placeholder="New password (min 10, letters + numbers)" className="input" value={pwd.new_password} onChange={(e)=>setPwd({...pwd, new_password:e.target.value})}/>
          <input data-testid="admin-reset-confirm" type="password" placeholder="Confirm new password" className="input" value={pwd.confirm} onChange={(e)=>setPwd({...pwd, confirm:e.target.value})}/>
          <button data-testid="admin-reset-submit" onClick={submit} disabled={loading || !token} className="btn-primary">
            {loading ? "Saving…" : "Reset password"}
          </button>
        </div>
      </div>
    </div>
  );
}
